import { Check, Copy } from 'react-feather';
import React from 'react';
import { useCopyToClipboard } from 'react-use';
import cx from 'classnames';

type Props = {
  value: string;
  className?: string;
};

const CopyWithAnimate: React.FC<Props> = (props) => {
  const [, copyToClipboard] = useCopyToClipboard();
  const [copied, setCopied] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 1500);

    return () => clearTimeout(timeout);
  }, [copied]);

  const onClick = () => {
    setCopied(true);
    copyToClipboard(props.value);
  };

  if (copied) {
    return (
      <span className={cx(props.className, 'ml-5', 'mr-5')}>
        <Check
          width={16}
          height={16}
          className={cx(props.className, 'primary-color')}
          onClick={onClick}
        />
      </span>
    );
  }

  return (
    <a
      onClick={onClick}
      className={cx(props.className, 'cursor-pointer', 'ml-5', 'mr-5')}
    >
      <Copy width={16} height={16} />
    </a>
  );
};

export default CopyWithAnimate;
